import "./core/index.js";
import "./define.js";
import "./core/lib/index.js";
import "./core/plugins/index.js";
import "./service.js";
import U from "./util/index.js";
U.loaderEnd();